import React, { useState } from 'react'
import { muiWithStyles, MuiGrid, MuiTypography, MuiIcon, MuiButton, MuiInputBase, MuiAddCircle, MuiSearchIcon, MuiHelpIcon, MuiInfoIcon } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import CreateScheduleDialog from './CreateScheduleDialog'
import { Link } from 'react-router-dom';
import routes from "../../../navigation/Routes"
const useStyles = theme => ({

});

function ScheduleTitleBarComponent(props) {
  const [openCreateScheduleDialog, setOpenDialog] = React.useState(false);


  const toggleCreateScheduleDialogMethod = event => {
    setOpenDialog(prevOpen => !prevOpen);
  };

  const createScheduleDialog = () => {
    const { classes, i18n } = props
    let scheduleObj = undefined
    return (
      <CreateScheduleDialog type="create" title={i18n.schedule.createScheduleText} description={i18n.schedule.createScheduleDescription} toggleCreateScheduleDialogMethod={toggleCreateScheduleDialogMethod} open={openCreateScheduleDialog} scheduleObj={scheduleObj} {...props} >
      </CreateScheduleDialog>

    )
  }

  const { classes, i18n } = props;


  return (
    <MuiGrid container xs={12} style={{ paddingTop: 10, paddingBottom: 5 }}>
      {openCreateScheduleDialog ? createScheduleDialog() : null}

      {/* <MuiGrid style={{marginRight:4}}>
        <MuiButton id='addButton' style={theme.secondaryButtonStyle} onClick={(event)=>props.showContextualHelp(props,event)}>


          <MuiHelpIcon color='primary' fontSize='small' style={{ padding: 1 }} />
    User Guide

        </MuiButton>
      </MuiGrid> */}


      <MuiGrid container xs={5} justify="space-between" alignItems='center' direction='row' style={{ paddingRight: 10, border: '1px solid ' + theme.palette.grey.main, width: 350 }}>
        <MuiGrid style={{ background: theme.palette.primary.main, height: '100%' }}>
          <MuiSearchIcon style={{ color: 'white', padding: 5 }} />
        </MuiGrid>
        <MuiGrid item xs>
          <MuiInputBase
            disabled={props.activeSchool.schedule_constraints !== undefined && props.activeSchool.schedule_constraints.length === 0 ? true : false}
            id='filterList'
            onChange={props.filterList}
            style={{ width: '100%', paddingLeft: 4 }}
            placeholder={i18n.schedule.scheduleSearchBarPlaceHolder}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}

          />
        </MuiGrid>

      </MuiGrid>

      <MuiGrid style={{ paddingLeft: 10 }}>
        <MuiButton id='addButton' style={theme.buttonStyleForNewSchedule} onClick={toggleCreateScheduleDialogMethod} >

          <MuiAddCircle fontSize='medium' style={{ color: theme.palette.orange, paddingRight: 3 }} />
          {i18n.schedule.createScheduleText}
        </MuiButton>

        {/* </Link> */}
      </MuiGrid>
      <MuiGrid container alignItems='center' xs={1} style={{ paddingLeft: 5 }}>
        <MuiGrid >
          <MuiInfoIcon color="primary" style={{ fontSize: "40px" }} onClick={(event) => props.showContextualHelp(props, event)} />
        </MuiGrid >
      </MuiGrid >
    </MuiGrid>

  )


}
export default muiWithStyles(useStyles)(ScheduleTitleBarComponent)